import css from './SearchButtonMobile.module.scss'
import React from 'react'
import Skeleton from 'react-loading-skeleton'

import { TICKETSMS_COLORS_LIGHTGREY, TICKETSMS_COLORS_WHITE } from 'utils/constants/colors'

export const SearchButtonMobileSkeleton: React.FC = () => {
  return (
    <Skeleton
      className={css.searchSkeleton}
      baseColor={TICKETSMS_COLORS_WHITE}
      borderRadius={12}
      highlightColor={TICKETSMS_COLORS_LIGHTGREY}
      inline
    />
  )
}
